import { useState } from "react";
// Materials
import { FormControl } from "@mui/material";
import { GridRowId, useGridApiContext } from "@mui/x-data-grid-premium";
// Components
import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";
// Types
import { TInputData } from "@/Layouts/types/InputComponents/InputFormExtension";
import { NumberOrString } from "@/Layouts/components/InputComponents/InputValue/types";

type InputEditInputCellProps = {
	id: GridRowId;
	field: string;
	value?: NumberOrString;
	error?: boolean;
};

export default function InputEditInputCell(props: Readonly<InputEditInputCellProps>) {
	const apiRef = useGridApiContext();
	const { id, field, value, error } = props;
	const [dataValue, setDataValue] = useState(value ?? 0);

	const handleActionUpdate = (updatedValue: NumberOrString) => {
		if (!Number(updatedValue)) {
			updatedValue = 0;
		}
		// `debounceMs` is important to avoid the input to be updated too often.
		apiRef.current.setEditCellValue({ id, field, value: updatedValue, debounceMs: 200 });
		setDataValue(updatedValue);
	};

	return (
		<FormControl className={"table-regular-cell-input"} fullWidth>
			<InputFormExtension
				data={
					[
						{
							type: "Dollar",
							min: -10000,
							max: 10000,
							decimalsEditable: true,
							decimals: 2,
						},
					] as TInputData[]
				}
				defaultType={"Dollar"}
				value={dataValue || 0}
				variant={error ? "error" : "standard"}
				sx={{ height: "27px" }}
				onActionUpdate={handleActionUpdate}
			/>
		</FormControl>
	);
}
